<div class="container">
  <div class="left_panel">

    <div class="header_and_filter">
      <div class="header">

        <div class="title">
          <div class="back_button">
            <img src="assets/icons/back_button.svg" alt="back icon" (click)="backButtonClick.emit()">
          </div>
          {{ title }}</div>

        <div class="btn_group">
          @if (showSecondaryActionsBtn) {
            <div class="add_new_button tertiary_button" (click)="secondaryButtonClick.emit();">
              <app-svg-icon [path]="'assets/icons/plus_icon.svg'" style="background:var(--brand-700)"></app-svg-icon>
              {{ secondaryActionBtnText }}
            </div>
          }

          <div class="add_new_button primary_button" (click)="primaryButtonClick.emit()">
            <app-svg-icon [path]="'assets/icons/plus_icon.svg'"></app-svg-icon>
            {{ primaryActionBtnText }}
          </div>
        </div>

      </div>
      <div class="search_bar_and_filter">
        <div class="search_container">
          <input
            type="text"
            name="search_table"
            id="search_table"
            [placeholder]="searchBarConfig?.placeHolder ?? 'Search...'"
            [(ngModel)]="searchTerm"
            (keyup)="handleTableSearch($event)"
          >
          <img src="assets/icons/search_icon.svg" class="search_icon">
        </div>
        <div class="filter_btn" (click)="openFilters()">
          <app-svg-icon [path]="'assets/icons/filter.svg'"></app-svg-icon>
          <app-svg-icon *ngIf="isFilterApplied" [path]="'assets/icons/circle_icon.svg'" class="filter_applied_icon"></app-svg-icon>
        </div>

      </div>
    </div>
    <div class="cards">

      @for (record of dataListResponse.records; track record.id) {
        <div class="card" (click)="setupCard(record.id)" [ngClass]="{
          'opened_card': openedCardId === record.id
        }">
          <input type="checkbox">
          <div class="card_content">
            <div class="card_header">
              <div class="title">
                {{ CommonUtils.getNestedValue(record, cardTitleKey) }}
                @if (record?.invoiceType === 'OTH') {
                  <app-svg-icon [path]="'assets/icons/miscellaneous_invoice_icon.svg'"></app-svg-icon>
                }
              </div>
              <div class="sub_title">{{ CommonUtils.getNestedValue(record, cardSubTitleKey) }}</div>
            </div>

            <div class="card_body">
              @for (key of getKeys(record); track key) {
                <div class="content">{{ record[key] }}</div>
                @if ($index < keysToDisplay.length - 1) {
                  <div>.</div>
                }
              }
            </div>
            <div [ngClass]="{
                'status_success' : record.status === INVOICE_STATUS.PAID,
                'status_pending' : record.status === INVOICE_STATUS.PENDING,
                'invoice_generated': record.status === INVOICE_STATUS.CREATED,
                'status_partially_paid' : record.status === INVOICE_STATUS.PARTIALLY_PAID}">
              <app-svg-icon [path]="'assets/icons/circle_icon.svg'"></app-svg-icon>
              <div class="text">{{ getStatusString(record.status) }}</div>
            </div>
          </div>
        </div>
      }
    </div>
    <mat-paginator [length]="dataListResponse.totalCount"
                   [pageSize]="dataListRequest.limit"
                   [pageSizeOptions]="[15,50,100]"
                   [pageIndex]="dataListRequest.page"
                   (page)="onPageChange($event)"
                   aria-label="Select page"
    >
    </mat-paginator>

  </div>
  <div class="right_panel">
    <ng-template #rightPanel></ng-template>
  </div>
</div>
